import styled, { css } from "styled-components";

const SafeSpotStyled = styled.div` 
    display: flex;
    flex-direction: column;
    gap: 32px;

 .titleWrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start ;
    gap: 24px;
 }

 .headerTitle {
    font-size: 2.6rem;
    font-weight: 700;
    color: #1B1E1C;
    font-family: ${props => props.theme.fontBold};
 }

 .addressWrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    align-items: flex-start;
    border-radius: 5px;
    border: 1px solid #CFD0CF;
 
 }

 .semiTitle {
    font-size: 1.4rem;
    font-weight: 700;
    color: #1B1E1C;
 }

 .formInfo {
    text-align: start;
    margin-bottom: 16px;
 }

 .formAdditionInfo {
    text-align: start;
    font-size: 1.2rem;
    font-weight: 400;
 }

 .addressInfo {
    text-align: left;
    width: 70%;
    font-size: 1.2rem;
    font-weight: 400;
    color: #1B1E1C;
 }

 form {
    display: flex;
    flex-direction: column;
    gap: 40px;

 }

p {
    font-size: 1.4rem;
    font-weight: 400;
    color: #1B1E1C;

}




.infoBoard { 
    width: 100%;
    height: 104px;
    border-radius: 5px;
    background: #DEEBF5;
    border: 2px solid #217BBE;
    padding: 16px 24px;
    display: flex;
    text-align: start;

    & p {
        margin: 0;
        font-size: 14;
        font-weight: 400;
        line-height: 24px;
    }

    & > strong {
        font-size: 1.4rem;
    }
}

.termsWrapper {
    display: flex;
    gap: 8px;
    flex-direction: column;
    align-items: start;
}

.terms {
    font-size: 1.4rem;
    font-weight: 700;
    color: #008755;
    cursor: pointer;
    text-decoration: underline;
}

.confirmationLabel {
    text-align: start;
    font-size: 1.4rem;
    font-weight: 400;
    color: #1B1E1C;
}

.submitPanel {
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: start !important;
}

`;

export { SafeSpotStyled };